import * as Msal from 'msal';
import axios from 'axios';

function authCallback(errorDesc, token, error) {
  // This function is called after loginRedirect and acquireTokenRedirect.
  // Not called with loginPopup
  // msal object is bound to the window object after the constructor is called.
  /* eslint-disable */
  console.log('token recieved');
  if (!token) {
    console.log(error);
    console.log(errorDesc);
  }
  /* eslint-enable */
}
const auth = {
  initialized: false,
  initialize(store) {
    if (auth.initialized) {
      return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
      axios.get('/config.json')
        .then((response) => {
          auth.config = response.data;
          auth.clientApplication = new Msal
            .UserAgentApplication(auth.config.clientId,
              `https://login.microsoftonline.com/${auth.config.tenantId}`,
              authCallback,
              {
                cacheLocation: 'localStorage',
                redirectUri: `${window.location.origin}/authorized`,
                navigateToLoginRequestUrl: false,
                postLogoutRedirectUri: `${window.location.origin}/signedout`,
              });
          if (auth.clientApplication.getUser()) {
            store.dispatch('User/setUser', auth.clientApplication.getUser());
          }
          auth.initialized = true;
          resolve();
        }, () => reject());
    });
  },
  clearUser(store) {
    auth.initialize(store).then(() => {
      auth.clientApplication.clearCache();
    });
  },
};

export default auth;
